<template>
  <div class="container">
    <el-button type="primary" @click="initWebsocket">初始化</el-button>
  </div>
</template>
<script>
import {mapGetters, mapActions, mapMutations} from 'vuex';
// import {client} from 'websocket';
import SockjsClient from 'sockjs-client';
const W3CWebSocket = require('websocket').w3cwebsocket;
export default {
  name: 'wsTest',
  components: {},
  data () {
    return {
      websocketClient: null
    };
  },
  mounted () {
    // this.setSubTitle('wsTest');
    // this.initWebsocket();
  },
  methods: {
    ...mapMutations([
      'setSubTitle'
    ]),
    initWebsocket () {
      console.log('初始化中');
      const url = 'ws://123.207.167.163:9010/ajaxchattest';
      let client = new W3CWebSocket(url);
      client.onerror = function() {
        console.log('Connection Error');
      };

      client.onopen = function() {
        console.log('WebSocket Client Connected');

        function sendNumber() {
          if (client.readyState === client.OPEN) {
            var number = Math.round(Math.random() * 0xFFFFFF);
            client.send(number.toString());
            setTimeout(sendNumber, 1000);
          }
        }
        sendNumber();
      };

      client.onclose = function() {
        console.log('echo-protocol Client Closed');
      };

      client.onmessage = function(e) {
        if (typeof e.data === 'string') {
          console.log("Received: '" + e.data + "'");
        }
      };
    },
    websocketClientOpen () {
      console.log("WebSocket连接成功");
    },
    WebsocketClientOnError(e) {
      console.log("WebSocket连接成功");
      console.log(e);
    },
    websocketClientOnMessage(e) {
      const redata = JSON.parse(e.data);
      console.log(redata.value);
    },
    websocketsend(agentData) { // 数据发送
      this.websocketClient.send(agentData);
    },
    websocketClientOnClose (e) {
      console.log("connection closed (" + e.code + ")");
    }
  },
  computed: {
    ...mapGetters([])
  },
  watch: {}
};
</script>
<style>

</style>
